import React, { useState } from "react";

const GameInstructions: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="mt-6">
      <div className="card-transparent bg-slate-800/30 backdrop-blur-sm">
        <div
          className="flex justify-between items-center cursor-pointer"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <h2 className="text-md font-medium">How to Play</h2>
          <span>{isExpanded ? "▲" : "▼"}</span>
        </div>

        {isExpanded && (
          <div className="mt-4 space-y-3 text-sm text-slate-300">
            <p>
              <span className="text-red-400 font-medium">Mafia:</span> Each
              night, work with other mafia to choose someone to eliminate.
            </p>
            <p>
              <span className="text-green-400 font-medium">Doctor:</span> Each
              night, choose one person to save from the mafia's attack.
            </p>
            <p>
              <span className="text-blue-400 font-medium">Detective:</span> Each
              night, investigate one player to learn if they're mafia.
            </p>
            <p>
              <span className="text-yellow-400 font-medium">Villager:</span> Use
              discussion and voting to identify and eliminate the mafia.
            </p>
            <p>
              During the day, all players discuss to identify the mafia. After
              discussion, players vote to eliminate a suspect.
            </p>
            <p>
              Villagers win if all mafia are eliminated. Mafia win if they equal
              or outnumber the innocent players.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GameInstructions;
